// extracted by mini-css-extract-plugin
export default {"productGallery":"uG-z","inQuickShop":"vG-z"};